import XLSX from 'xlsx';

export function parseXLSX(xlsx) {
  const workbook = XLSX.read(xlsx, { type: 'array' });
  let parsedXLSX = [[]];
  if (workbook.SheetNames.length === 0) {
    parsedXLSX = parsePreabmle(workbook.Preamble);
  }
  for (let sheetName of workbook.SheetNames) {
    const currentSheet = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName], {
      header: 1,
    });
    if (currentSheet.length > parsedXLSX.length) {
      parsedXLSX = currentSheet;
    }
  }
  const variables = {
    x: {
      data: parsedXLSX.map((row) => row[0]),
      units: 'mL/100g',
      label: 'Oil volume per sample quantity',
    },
    y: {
      data: parsedXLSX.map((row) => row[1]),
      units: 'mNm',
      label: 'Torque',
    },
  };
  return variables;
}

function parsePreabmle(preamble) {
  const keys = Object.keys(preamble).filter((key) => key.match(/^[AB]/));
  const matrix = [[]];
  for (let key of keys) {
    let row = Number(key.replace(/[^0-9]+/g, '')) - 1;
    let column = key.replace(/[0-9]+/g, '').charCodeAt(0) - 65;
    if (!matrix[row]) matrix[row] = [];
    matrix[row][column] = preamble[key].v;
  }
  return matrix;
}
